 import { Component } from "react";
import { CustomDropdown } from "./custom-dropdown.component";
import { Errors } from "react-redux-form";
import { actions } from 'react-redux-form';
import store from "../../../store";

import Translation from "../translation/translation.component";
import CrudTable from "../details-table/crud-table.component";
import { NotificationModal } from "../modal/notification-modal.component";
import { InputField } from "./input-filter-component";
import { connect } from "react-redux";
import { CONFIRMATION_VALUE, TRANSLATIONS as translation } from "../../../utils/constant.utils";
import { ConfirmationNotificationModal } from "../modal/confirmation-modal.component";
import { ACTION_TYPES, DISPLAY_OPTION, MAX_LENGTH, MODAL_CUSTOM_MESSAGE, Selected_Index } from "../../../constants/external-constants";
import { Button } from "react-bootstrap";
import CustomSearchableSelectWrapper from "./custom-searchable-select-wrapper.component";
import { bindActionCreators } from "@reduxjs/toolkit";
import Moment from 'moment';
import { inventoryCircuitActions } from "../../../store/external/inventory/circuit.reducer";
import { inventoryCostAllocationActions } from "../../../store/external/inventory/add-cost-allocation.reducer";
import { convertToFormatLocalDate, convertToTimeZoneDate, isInteger } from "../../../utils/helpers.utils";
import CustomSearchableDropdownWrapper from "./custom-dropdown/custom-searchable-dropdown-wrapper";

class AddCostAllocation extends Component {
    constructor(props){
        super(props);        
        this.state={         
          showNotif:false,
          haveError:false,
          modalMessage:'',
          isMaxPecent: false,
          glCode: null,
          costCode: null,
          percent: null,
          activeDropdown:false,
          dataTable:[[]],
          headerTable:[],       
          totalPercent: 0,  
          showModal: false,    
          updatePlanComponentDetails: false,    
          fieldType:[{
            name:'GLCode',
            type:'searchabledropdown',
            selected:'GLCodeID',
            labelSelected: 'GLCodeName',
            required: true,
            data: []
          },{
            name:'CostCode',
            type:'searchabledropdown',
            selected:'CostCodeID', 
            labelSelected: 'CompanyCode',
            optionLabelKey:{
                Key: 'Key',
                Value: 'Value',                                    
                Label: 'Label',
                CustomData: 'CustomData'
             },
            data: []
          
          },{
            name:'CostCodePercent',
            type:'number',
            numberType:'decimal',
            required:true
                }],
          costCentersPage: 1,
          glCodePage: 1
        }
    }

    async componentDidMount() {
        const { circuitCostAllocation } = this.props.inventoryCostAllocation;
        const { financeId } = this.props;
        const circuitId = 0;

        this.props.getInventoryCircuitGlCodeList();
        this.props.getInventoryCircuitCostCenterList();

        if (financeId !== 0) {
            this.props.getBillingAccountCostAllocation(financeId).then(() => {

                const headerData = circuitCostAllocation?.datatable[0]?.HeaderItem;
                const dataItem = circuitCostAllocation?.datatable[0]?.dataItem;

                this.setState((prevState) => {
                    const updatedState = {};

                    if (headerData) {
                        updatedState.headerTable = [...prevState.headerTable, headerData[0]];
                    }

                    if (dataItem) {
                        if (dataItem[0]) {
                            const updatedDataTable = [...prevState.dataTable];
                            updatedDataTable[0]?.push(dataItem);

                            updatedState.totalPercent = circuitCostAllocation?.totalCostCodePercent;
                            updatedState.dataTable = updatedDataTable[0];
                        } else {
                            updatedState.dataTable = [...prevState.dataTable, dataItem[0]];
                        }
                    }

                    return updatedState;
                });
            });
        } else {
            const { headerTable, dataTable } = this.state;

            this.props.getAddCostAllocation(circuitId).then(() => {
                const { circuitCostAllocation } = this.props.inventoryCostAllocation;
                const headerData = circuitCostAllocation?.datatable[0]?.HeaderItem;
                const dataItem = circuitCostAllocation?.datatable[0]?.dataItem;
                if (headerData) {
                    this.setState({ headerTable: [...headerTable, headerData[0]] })
                }

                if (dataItem) {
                    this.setState({ dataTable: [...dataTable, dataItem[0]] })
                }
            });
        }
    }

    loadMoreGLCodes = (searchString) => {
        const { inventoryCircuit } = this.props;
        this.props.getInventoryCircuitGlCodeList(inventoryCircuit.glCodePage + 1, searchString);
    };

    loadMoreCostCenters = (searchString) => {
         const { inventoryCircuit } = this.props;
        this.props.getInventoryCircuitCostCenterList(inventoryCircuit.costCenterPage + 1, searchString);
    };

    handleSearchGLCodes = (query) => {
        this.props.getInventoryCircuitGlCodeList(1, query);

        if (query == '') {
            this.setState({ glCode: null })
        }
    }

    handleSearchCostCode = (query) => {
        this.props.getInventoryCircuitCostCenterList(1, query);

        if (query == '') {
            this.setState({ costCode: null })
        }
    }

    componentDidUpdate(prevProps) {
        const { inventoryCircuit } = this.props;
        const { fieldType } = this.state;

        let shouldUpdateFieldType = false;
        let updatedFieldType = [...fieldType];

        if (prevProps.inventoryCircuit.circuitGlCodeList !== inventoryCircuit.circuitGlCodeList) {
            const glCodeList = inventoryCircuit.circuitGlCodeList;

            // Update GLCode field data
            updatedFieldType = updatedFieldType.map((fieldData) => {
                if (fieldData.name === "GLCode") {
                    shouldUpdateFieldType = true;
                    return {
                        ...fieldData,
                        data: glCodeList,
                    };
                }
                return fieldData;
            });
        }

        if (prevProps.inventoryCircuit.circuitCostCenterList !== inventoryCircuit.circuitCostCenterList) {
            const modifiedCostcenterOptions = this.modifyOption(inventoryCircuit.circuitCostCenterList);

            // Update Cost Center field data
            updatedFieldType = updatedFieldType.map((fieldData) => {
                if (fieldData.name === "CostCode") {
                    shouldUpdateFieldType = true;
                    return {
                        ...fieldData,
                        data: modifiedCostcenterOptions,
                    };
                }
                return fieldData;
            });
        }

        if (shouldUpdateFieldType && JSON.stringify(updatedFieldType) !== JSON.stringify(fieldType)) {
            this.setState({ fieldType: updatedFieldType });
        }
    }

    modifyOption = (options) =>{
        return options.map(option => ({
            ...option,
            Value: `${option.Value}`,
            Label: `${option.Label}`,
            CustomData: `${option.Value} ~ ${option.Label}`
        }));
    }

    handleOnChange = (e) => {
        const value = e.target.value;

        if (value === '' || /^(\d+|\d*\.\d*)?$/.test(value)) {
            this.setState({ percent: value });
        }
    };
    
    toggleActiveState = () => {
        this.setState(prevState => ({ activeDropdown: !prevState.activeDropdown }));
    }

    handleCloseNotif = () => {
        this.setState({ showNotif: false });
    }   
    
    toLocaleLanguage = (key) => {
          const { locale } = this.props;
          if (locale === null || locale === '' || locale === undefined)
              return translation[translation['defaultLocaleLanguage']][key];
  
          return translation[locale][key];
    }

    handleResetField = () => {
        this.setState({
            glCode: null,
            costCode: null,
            percent: null,
            haveError: false,
            showNotif: false,
            modalMessage: '',
            isMaxPecent: false,
            tableHasError: false,

        })
    }


    
      handleAddData = () => {
        const { inventoryCircuit } = this.props;
        //filter glcode details
        const circuitGlCodeList= inventoryCircuit.circuitGlCodeList;
        const circuitGlCodeListFilter = circuitGlCodeList.filter(x=>x.Key===parseInt(this.state.glCode))

        //filter costcode details

        const circuitCostCodeList = inventoryCircuit.circuitCostCenterList;
        const circuitCostCodeListFilter = circuitCostCodeList.filter(x=>x.Key === parseInt(this.state.costCode))

        //validate data
        if(this.handleValidateData()) {
            return
        }
        

        this.setState((prevState) => {
            const { activeTimeZoneOffset } = this.props.adminSetting;
            const updatedDataTable = [...prevState.dataTable];            
            var newItem=[]
            if (Array.isArray(updatedDataTable[0])) {                
                newItem = {
                    Key: Math.floor(Math.random() * 1000),
                    CostAllocationID: -1,
                    GLCodeID: circuitGlCodeListFilter[0].Key,
                    GLCode: circuitGlCodeListFilter[0].Value,
                    GLCodeName: circuitGlCodeListFilter[0].Label,
                    CostCodeID: circuitCostCodeListFilter[0].Key,
                    CostCode: circuitCostCodeListFilter[0].Value,
                    CompanyCode: circuitCostCodeListFilter[0].Label,
                    CostCodePercent: this.state.percent,
                    LastModified: `${sessionStorage.FirstName} ${sessionStorage.LastName} on ${Moment(convertToTimeZoneDate(new Date(),activeTimeZoneOffset?.UtcOffset)).format('L')} ${Moment(convertToTimeZoneDate(new Date(),activeTimeZoneOffset?.UtcOffset)).format('LT')}`,
                };
                updatedDataTable[0].push(newItem);
            } else {
                updatedDataTable[0] = [newItem];
            }
            this.props.handleFetchData(updatedDataTable)

            const costCodePercent= updatedDataTable[0].reduce((acc,percent)=> acc + parseFloat(percent.CostCodePercent || 0), 0 )
            this.setState({totalPercent:costCodePercent})
            return { dataTable: updatedDataTable };
        });

        this.handleResetField();
    };


    handleClickAddBtn = ()=> {
        this.setState({
            showModal:true,
        })
    }

    handleConfirmationModal = (buttonType) => {
          
            if (buttonType === CONFIRMATION_VALUE.Ok) {
                    this.handleAddData();
                this.setState(prev => ({
                    showModal: !prev.showModal,
                    enableEdit: false,
                    updateCostAllocationDetails: false,
                    isExist: false,
                    isGreater: false
                }))
    
            } else {
                this.setState({
                    showModal: false
                });  
        }
        store.dispatch(actions.resetErrors('billingAccountForm'));
        }

    updateData = (key,newData) => {
        const { activeTimeZoneOffset } = this.props.adminSetting;

        this.setState((prevState) => {
            const updatedDataTable = [...prevState.dataTable];

            if (Array.isArray(updatedDataTable[0])) {
                const index = updatedDataTable[0].findIndex((item) => item.Key === key);

                if (index !== -1) {
                    updatedDataTable[0][index] = {
                        ...updatedDataTable[0][index],
                        ...newData[index],
                        LastModified: `${sessionStorage.FirstName} ${sessionStorage.LastName} on ${Moment(convertToTimeZoneDate(new Date(), activeTimeZoneOffset?.UtcOffset)).format('L')} ${Moment(convertToTimeZoneDate(new Date(), activeTimeZoneOffset?.UtcOffset)).format('LT')}`,
                    };
                }

                return { dataTable: updatedDataTable };
            }
            return null;
        }, () => {
            this.props.handleFetchData(this.state.dataTable);
        });
        store.dispatch(actions.resetErrors('billingAccountForm'));
    };

    handleHaveError = (message,maxPercent,duplicate) =>{
        this.setState({
            showNotif:true,
            haveError:duplicate,
            isMaxPecent:maxPercent,
            modalMessage:message,
        })
    }

    handleDeleteData = (key) => {
        this.setState((prevState) => {
            const updatedDataTable = [...prevState.dataTable];
    
            if (Array.isArray(updatedDataTable[0])) {
                updatedDataTable[0] = updatedDataTable[0].filter((x) => x.Key !== key);
            }
            this.props.handleFetchData(updatedDataTable)
            const costCodePercent = updatedDataTable[0].reduce((acc, percent) => acc + parseFloat(percent.CostCodePercent || 0), 0)
            this.setState({ totalPercent: costCodePercent })

            return { dataTable: updatedDataTable };
        });
    };
    
    
    handleValidateData=()=>{
            const { dataTable, costCode, glCode, percent } = this.state;
            //check if data already exist
            if(dataTable[0]?.length !== 0) {
                const alreadyExist = dataTable[0]?.some(
                    (item)=> 
                        parseInt(item.CostCodeID) === parseInt(costCode) && 
                        parseInt(item.GLCodeID) === parseInt(glCode)
                )

                if(alreadyExist) {
                    this.handleHaveError('gl_cost_center_already_exist',false,true);
                    return true
                }
            }

            //calculate percentage

            if(parseFloat(percent) > 100) {
                this.handleHaveError('percentage_cannot_exceed',true,false);
                return true
            }

            if(dataTable[0]?.length !== 0) {
                const totalPercent = dataTable[0]?.reduce(
                    (acc, item) => acc + parseFloat(item.CostCodePercent || 0),
                    0
                );

                const updatedTotalPercent = totalPercent + parseFloat(percent);

                if(updatedTotalPercent > 100) {
                    this.handleHaveError('percentage_cannot_exceed',true,false);
                    return true;
                }
            }

            return false
    }

    handleTableValidation = (key, updatedData) => {
        console.log(updatedData)
        //check if has duplicate value
        const setCombination = new Set();
        const duplicates=[];

        updatedData?.forEach((item)=>{
            const combination=`${item.CostCodeID}-${item.GlcodeId}}`;
            if(setCombination.has(combination)) {
                duplicates.push(item);
            } else {
                setCombination.add(combination)
            }
        })

        if(duplicates.length > 0) {
            this.setState({tableHasError:true})
            this.handleHaveError('gl_cost_center_already_exist',false,false);
            return ["CostCode", "GLCode"]
        }

        //total percent
        const costCodePercent= updatedData.reduce((acc,item)=> acc + parseFloat(item.CostCodePercent || 0),0)
        if(costCodePercent > 100) {          
            this.setState({tableHasError:true})
            this.handleHaveError('percentage_cannot_exceed',false,false);
            return ["CostCodePercent"]
        }
        else {
            this.setState({totalPercent:costCodePercent})
        }

        return null
    };
    
    handleBlur = (e) => {
        const { value } = e.target;
        if(isInteger(value)) {
            this.setState({ percent: parseFloat(value)});
        }
        if(!value) {
            this.setState({percent: ""})
        }
    };

    handleCancel = () => {
        this.setState({
            glCode: null,
            costCode: null,
            percent: null,
            haveError: false,
            showNotif: false,
            modalMessage: '',
            isMaxPecent: false,
            tableHasError: false,
            activeDropdown: false
        })
    }

    searchGLCode = (searchString) => {
        this.props.onSearchGLCodes(searchString);
    }

    searchCostCenter = (searchString) => {
        this.props.onSearchCostCenter(searchString);
    }


    render(){
        const { inventoryCircuit} = this.props;
        const { glCode, costCode, percent } = this.state;
        const modifiedCostcenterOptions = this.modifyOption(inventoryCircuit.circuitCostCenterList );
        const disabledBtn = (!glCode || !costCode || !percent);
        return(
            <div>
                <Errors model="billingAccountForm.financeCostAllocation" className="has-error" />
                <div className="control-container">
                    <CustomDropdown
                        label={<Translation translationKey={"add_cost_allocation"} />}
                        activeDropdown={this.state.activeDropdown}
                        toggleActiveState={this.toggleActiveState}
                    >
                        <div className="add-sim-container add-cost-allocation-cont">
                            <div className="details-4-col-26-container">
                                <CustomSearchableDropdownWrapper
                                    label={`${this.toLocaleLanguage('capital_gl_code')}`}
                                    options={inventoryCircuit.circuitGlCodeList ? inventoryCircuit.circuitGlCodeList : []}
                                    selected={this.state.glCode}
                                    onChange={(e) => { this.setState({ glCode: e }) }}
                                    placeholder={`${this.toLocaleLanguage('select_placeholder')}`}
                                    fieldProp='.form'
                                    isError={this.state.haveError}
                                    optionLabelKey={{
                                        Key: 'Key',
                                        Value: 'Value'
                                    }}
                                    customClass={`required`}
                                    maxLength={MAX_LENGTH.limit_100}
                                    disabled={false}

                                    onSearchChange={this.handleSearchGLCodes}
                                    onLoadMore={this.loadMoreGLCodes}
                                    hasMore={inventoryCircuit.hasMoreGLCode}
                                />

                                <CustomSearchableDropdownWrapper
                                    label={`${this.toLocaleLanguage('capital_cost_center')}`}
                                    options={inventoryCircuit.circuitCostCenterList ? modifiedCostcenterOptions : []}
                                    selected={this.state.costCode}
                                    onChange={(e) => { this.setState({ costCode: e }) }}
                                    placeholder={`${this.toLocaleLanguage('select_placeholder')}`}
                                    name="inventoryEquipmentForm.costCodeId"
                                    fieldProp='.form'
                                    tagName='tagName'
                                    isError={this.state.haveError}
                                    optionLabelKey={{
                                        Key: 'Key',
                                        Value: 'Value',
                                        Label: 'Label',
                                        CustomData: 'CustomData'
                                    }}
                                    customClass={`required`}
                                    maxLength={MAX_LENGTH.limit_100}
                                    disabled={false}

                                    onSearchChange={this.handleSearchCostCode}
                                    onLoadMore={this.loadMoreCostCenters}
                                    hasMore={inventoryCircuit.hasMoreCostCenter}
                                />
                                <InputField
                                    customWrapper={`${this.state.isMaxPecent ? 'border-red' : ''}`}
                                    type="text"
                                    label={`${this.toLocaleLanguage('percent')}`}
                                    inputValue={this.state.percent}
                                    placeholder={this.toLocaleLanguage("enter_text_placeholder")}
                                    onChange={(e) => this.handleOnChange(e, 'percent')}   
                                    disabled={false}
                                    requiredField={true}
                                    maxLength={MAX_LENGTH.limit_100}
                                />
                                <div className="add-button-container custom-add-button">
                                    <div className="btn-tooltiptext">
                                        <Button variant="outline-secondary" className="btn-custom-violet-hover-outline" onClick={this.handleCancel}>Cancel</Button>
                                        <span className="tooltip-text">{<Translation translationKey="cancel_add_cost_allocation" />}</span>
                                    </div>

                                    <ConfirmationNotificationModal
                                        show={this.state.showModal}
                                        message={this.state.updatePlanComponentDetails ? MODAL_CUSTOM_MESSAGE.update_details : MODAL_CUSTOM_MESSAGE.add_details}
                                        title={this.state.updatePlanComponentDetails ? 'Update' : 'Add'}
                                        handleModal={this.handleConfirmationModal}
                                        customClass={'comment-notification-modal modal-text-bold'}
                                    />

                                    <div className={'btn-tooltiptext'}>
                                        <Button
                                            disabled={(this.props.isReadOnly || this.props.isReadAndExtractOnly) ? true : disabledBtn}
                                            onClick={this.handleClickAddBtn}
                                            variant="primary"
                                            className="btn-add"
                                        >
                                            {`${ACTION_TYPES.Add}`}

                                        </Button>
                                        <span className="tooltip-text"><Translation translationKey="add_cost_allocation_details" /></span>
                                    </div>
                                </div>
                            </div>
                            <div className="details-table-container ">
                                <CrudTable
                                    dataTable={this.state.dataTable[0]}
                                    headerTable={this.state.headerTable}
                                    fieldType={this.state.fieldType}
                                    fetchDropdownValue={this.fetchDropdownValue}
                                    updateData={this.updateData}
                                    handleDeleteData={this.handleDeleteData}
                                    customValidation={this.handleTableValidation}
                                    haveDeleteAndEditBtn={(this.props.isReadAndWrite ? true : false)}
                                    hasScroll={false}     
                                />
                            </div>
                            <div className="total-allocated-container">
                                <span>
                                    Total percent allocated: <span className={this.state.totalPercent < 100 ? "allocated-percent-less100" : "allocated-percent"}>
                                        {this.state.totalPercent}%</span>
                                </span>
                            </div>
                        </div>

                    </CustomDropdown>
                </div>
                 <NotificationModal
                      show={this.state.showNotif}
                      title={(this.state.haveError || this.state.tableHasError || this.state.isMaxPecent) ? 'Error' : 'Success'}
                      message={<Translation translationKey={this.state.modalMessage} />}
                      handleModal={this.handleCloseNotif}
                      customClass={'comment-notification-modal notification-footer modal-text-bold'}
                  />                 
            </div>
        )
    }
}


export default connect(
    state=> {
        const { translation, inventoryCostAllocation,inventoryCircuit, adminSetting
        } = state;
       
        return {
            inventoryCostAllocation,
            inventoryCircuit,
            adminSetting,
           ...translation
        };
    },
    dispatch => ({
            ...bindActionCreators(
                Object.assign({}
                    , inventoryCircuitActions
                    , inventoryCostAllocationActions),                   
                    dispatch
            ),            
            
        })
)(AddCostAllocation);